export default {
  mobile: '(max-width: 775px)',
  tablet: '(min-width: 776px) and (max-width: 1368px)',
  desktop: '(min-width: 1369px)',
};
